import { createActionWithPayload } from "store/helpers";
import { ActionTypes } from "./types";
import { createAction } from "@reduxjs/toolkit";
import { IAvaCalc } from "@deltasge/marauders-map";

export const request = createAction<void>(ActionTypes.REQUEST);
export const success = createActionWithPayload<IAvaCalc[]>(ActionTypes.SUCCESS);
export const failure = createAction<void>(ActionTypes.FAILURE);
